module.exports = __webpack_public_path__ + "static/media/Enviar_mensaje.5f8a68c3.png";